import { render, staticRenderFns } from "./MainFileManager.vue?vue&type=template&id=44aa9340"
import script from "./MainFileManager.vue?vue&type=script&lang=js"
export * from "./MainFileManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports